// extracted by mini-css-extract-plugin
export default {"root":"th-label_root__liwQt","label":"th-label_label__uNXie","placeHolderShimmer":"th-label_placeHolderShimmer__ccIVC"};